var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultWinery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 32C15.5523 32 16 31.5523 16 31C16 30.4477 15.5523 30 15 30C14.4477 30 14 30.4477 14 31C14 31.5523 14.4477 32 15 32Z",
    fill: "url(#paint0_linear_2087_12102)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 38C42.4 38 42 38.4 42 39V42H2V40H4H40C40.6 40 41 39.6 41 39V23C41 22.4 40.6 22 40 22C39.4 22 39 22.4 39 23V38H9V24H17V35C17 35.6 17.4 36 18 36C18.6 36 19 35.6 19 35V23C19 22.4 18.6 22 18 22H8C7.4 22 7 22.4 7 23V38H4H1C0.4 38 0 38.4 0 39V43C0 43.6 0.4 44 1 44H43C43.6 44 44 43.6 44 43V39C44 38.4 43.6 38 43 38Z",
    fill: "url(#paint1_linear_2087_12102)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.5V35C3 35.6 3.4 36 4 36C4.6 36 5 35.6 5 35V20.6C5.6 20.9 6.3 21 7 21C9.1 21 10.9 19.9 12 18.3C13.1 19.9 14.9 21 17 21C19.1 21 20.9 19.9 22 18.3C23.1 19.9 24.9 21 27 21C29.1 21 30.9 19.9 32 18.3C33.1 19.9 34.9 21 37 21C40.3 21 43 18.3 43 15C43 14.9 43 14.9 43 14.8L41 5.9V1C41 0.4 40.6 0 40 0H4C3.4 0 3 0.4 3 1V6.9L1 14.8C1 14.9 1 15 1 15C1 16.8 1.8 18.4 3 19.5ZM37 19C34.8 19 33 17.2 33 15C33 14.4 32.6 14 32 14H26C25.4 14 25 14.4 25 15C25 15.6 25.4 16 26 16H30.9C30.5 17.7 28.9 19 27 19C24.8 19 23 17.2 23 15C23 14.4 22.6 14 22 14H16C15.4 14 15 14.4 15 15C15 15.6 15.4 16 16 16H20.9C20.5 17.7 18.9 19 17 19C14.8 19 13 17.2 13 15C13 14.4 12.6 14 12 14H6C5.4 14 5 14.4 5 15C5 15.6 5.4 16 6 16H10.9C10.5 17.7 8.9 19 7 19C4.8 19 3.1 17.3 3 15.1L4.8 8H11V11C11 11.6 11.4 12 12 12C12.6 12 13 11.6 13 11V8H21V11C21 11.6 21.4 12 22 12C22.6 12 23 11.6 23 11V8H31V11C31 11.6 31.4 12 32 12C32.6 12 33 11.6 33 11V8H39.4L40.7 14H36C35.4 14 35 14.4 35 15C35 15.6 35.4 16 36 16H40.9C40.4 17.7 38.9 19 37 19ZM5 2H39V6H5V2Z",
    fill: "url(#paint2_linear_2087_12102)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 22C21.4 22 21 22.4 21 23V35C21 35.6 21.4 36 22 36H36C36.6 36 37 35.6 37 35V23C37 22.4 36.6 22 36 22H22ZM35 34H23V24H35V34Z",
    fill: "url(#paint3_linear_2087_12102)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2087_12102",
    x1: 15,
    y1: 30,
    x2: 15,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2087_12102",
    x1: 22,
    y1: 22,
    x2: 22,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2087_12102",
    x1: 22,
    y1: 0,
    x2: 22,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2087_12102",
    x1: 29,
    y1: 22,
    x2: 29,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultWinery);
export default __webpack_public_path__ + "static/media/default-winery.723c9c4a.svg";
export { ForwardRef as ReactComponent };